var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 66,
    viewBox: "0 0 100 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_420_1535)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 33,
    r: 23,
    fill: "#FF6019",
    fillOpacity: 0.09
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_1535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 33C48.0878 33 49.1512 32.6774 50.0556 32.0731C50.9601 31.4687 51.6651 30.6098 52.0813 29.6048C52.4976 28.5998 52.6065 27.4939 52.3943 26.427C52.1821 25.3601 51.6583 24.3801 50.8891 23.6109C50.1199 22.8417 49.1399 22.3179 48.073 22.1057C47.0061 21.8935 45.9002 22.0024 44.8952 22.4187C43.8902 22.8349 43.0313 23.5399 42.4269 24.4444C41.8226 25.3488 41.5 26.4122 41.5 27.5C41.5015 28.9582 42.0814 30.3563 43.1125 31.3875C44.1437 32.4186 45.5418 32.9985 47 33ZM47 23.8333C47.7252 23.8333 48.4341 24.0484 49.0371 24.4513C49.6401 24.8542 50.11 25.4268 50.3876 26.0968C50.6651 26.7668 50.7377 27.5041 50.5962 28.2153C50.4547 28.9266 50.1055 29.5799 49.5927 30.0927C49.0799 30.6055 48.4266 30.9547 47.7153 31.0962C47.0041 31.2377 46.2668 31.1651 45.5968 30.8876C44.9268 30.61 44.3542 30.1401 43.9513 29.5371C43.5484 28.9341 43.3333 28.2252 43.3333 27.5C43.3333 26.5275 43.7196 25.5949 44.4073 24.9073C45.0949 24.2196 46.0275 23.8333 47 23.8333Z",
    fill: "#FF6019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 34.834C44.8127 34.8364 42.7157 35.7064 41.169 37.253C39.6224 38.7997 38.7524 40.8967 38.75 43.084C38.75 43.3271 38.8466 43.5603 39.0185 43.7322C39.1904 43.9041 39.4236 44.0007 39.6667 44.0007C39.9098 44.0007 40.1429 43.9041 40.3148 43.7322C40.4868 43.5603 40.5833 43.3271 40.5833 43.084C40.5833 41.3822 41.2594 39.7501 42.4627 38.5467C43.6661 37.3434 45.2982 36.6673 47 36.6673C48.7018 36.6673 50.3339 37.3434 51.5373 38.5467C52.7406 39.7501 53.4167 41.3822 53.4167 43.084C53.4167 43.3271 53.5132 43.5603 53.6852 43.7322C53.8571 43.9041 54.0902 44.0007 54.3333 44.0007C54.5764 44.0007 54.8096 43.9041 54.9815 43.7322C55.1534 43.5603 55.25 43.3271 55.25 43.084C55.2476 40.8967 54.3776 38.7997 52.831 37.253C51.2843 35.7064 49.1873 34.8364 47 34.834Z",
    fill: "#FF6019"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_420_1535",
    x: -6,
    y: -12,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629948 0 0 0 0 0.749531 0 0 0 0 0.854167 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_1535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_420_1535",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_1535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(36 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.0409360a.svg";
export { ForwardRef as ReactComponent };